"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
  _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
  _isomorphicUnfetch = _interopRequireDefault(require("isomorphic-unfetch")),
  _index = require("./index");
function onSubmit() {
  return _onSubmit.apply(this, arguments);
}
function _onSubmit() {
  return _onSubmit = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b, c, d, e, f, g, h, i, j, k, l, m, n) {
    var o, p, q, r, s, t, u, v, w;
    return _regenerator["default"].wrap(function (a) {
      for (;;) {
        switch (a.prev = a.next) {
          case 0:
            if (o = c.onSubmit, p = new FormData(b.target), b.preventDefault(), q = (0, _index.forceValidation)(e, d, k, l), q) {
              a.next = 6;
              break;
            }
            return a.abrupt("return", !1);
          case 6:
            o ? o(p) : (g(!0), i(!1), j(!1), m(!1), n(!1), r = c.formID, s = c.backendUrl, t = c.jumpToConfirmation, u = c.onSubmitSuccess, v = c.onError, w = s.substring(0, s.indexOf("/wp-json")), (0, _isomorphicUnfetch["default"])("".concat(w, "/wp-json/gf/v2/forms/").concat(r, "/submissions"), {
              method: "POST",
              body: p
            }).then(function (a) {
              return a.json();
            }).then(function (a) {
              if (a && a.is_valid) {
                if (u) {
                  var j = u(a);
                  if (!j) return !1;
                }
                var b = a.confirmation_message,
                  d = b || !1,
                  e = d.type,
                  h = d.link;
                if (e && h && "redirect" === e && "undefined" != typeof window) return window.location.replace(h), !1;
                g(!1), i(!0), m(b), t && (0, _index.scrollToConfirmation)(c, f);
              } else throw {
                response: a
              };
            })["catch"](function (a) {
              var b = a && a.response && a.response.validation_messages ? a.response.validation_messages : "Something went wrong";
              v ? (v(b), g(!1), j(!0)) : (g(!1), j(!0), n(b)), t && (0, _index.scrollToConfirmation)(c, f);
            }));
          case 7:
          case "end":
            return a.stop();
        }
      }
    }, a);
  })), _onSubmit.apply(this, arguments);
}
var _default = onSubmit;
exports["default"] = _default;